module.exports = __webpack_public_path__ + "media/images/jcrop-155428c6a87137941f5815e928e56104.gif";